"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  fill: transparent;\n  stroke: ", ";\n  stroke-width: 5;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fill: transparent;\n  stroke: ", ";\n  stroke-width: 50;\n  stroke-dasharray: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transform: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PieProgressIndicator = function PieProgressIndicator(_ref) {
  var percentage = _ref.percentage,
      big = _ref.big;
  var calculatedPercentage = percentage * 1.58;
  return _react.default.createElement(Wrapper, {
    size: big
  }, _react.default.createElement("svg", {
    width: "106",
    height: "106"
  }, _react.default.createElement(OuterCircle, {
    r: "25",
    cx: "53",
    cy: "53",
    percentage: calculatedPercentage
  }), _react.default.createElement(BorderCircle, {
    r: "50",
    cx: "53",
    cy: "53"
  })));
};

var Wrapper = _styledComponents.default.div(_templateObject(), function (_ref2) {
  var size = _ref2.size;
  return size ? 'rotate(-90deg)' : 'rotate(-90deg) scale(0.18)';
});

var OuterCircle = _styledComponents.default.circle(_templateObject2(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.brand.primary;
}, function (_ref4) {
  var percentage = _ref4.percentage;
  return "".concat(percentage, " 158");
});

var BorderCircle = _styledComponents.default.circle(_templateObject3(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.brand.primary;
});

PieProgressIndicator.propTypes = {
  /** The percentage that should be displayed. */
  percentage: _propTypes.number.isRequired,

  /** Set big to true to show a bigger version of the indicator. */
  big: _propTypes.bool
};
var _default = PieProgressIndicator;
exports.default = _default;